module.exports = __webpack_public_path__ + "img/video.565700bd.svg";